import type { EnvironmentVariables } from 'appConfig';
import { get } from '@quromedical/utils';
import Constants from 'expo-constants';

const Env: EnvironmentVariables = get(Constants, 'expoConfig.extra.config');

export const config = {
  trpcURL: Env.API_BASE_URL,
  stage: Env.STAGE,
  releaseId: Env.BUILD_ID,
  vitalsWebsocketUrl: Env.VITALS_WEBSOCKET_URL,
  auth0Domain: Env.AUTH0_DOMAIN,
  auth0ClientId: Env.AUTH0_APP_CLIENT_ID,
  segmentWriteKey: Env.SEGMENT_WRITE_KEY,
  appURL: Env.APP_URL,
};

type Config = Record<keyof typeof config, string>;

export const env = config as Config;
